import service from '@/utils/request';
export var getDataCount = function getDataCount(data) {
  return service({
    url: "/xcpGameData/dataCount",
    method: 'post',
    data: data
  });
};
export var getServerCount = function getServerCount(data) {
  return service({
    url: "/xcpGameData/serverCount",
    method: 'post',
    data: data
  });
};
export var getServerHourData = function getServerHourData(data) {
  return service({
    url: "/xcpGameData/serverAnalysis/serverHourData",
    method: 'post',
    data: data
  });
};
export var getServerOpenDayCount = function getServerOpenDayCount(data) {
  return service({
    url: "/xcpGameData/serverOpenDayCount",
    method: 'post',
    data: data
  });
};
export var getAdCount = function getAdCount(data) {
  return service({
    url: "/xcpGameData/adCount",
    method: 'post',
    data: data
  });
};
export var getNewCount = function getNewCount(data) {
  return service({
    url: "/xcpGameData/newCount",
    method: 'post',
    data: data
  });
};
export var getServerList = function getServerList(data) {
  return service({
    url: "/xcpGameData/serverList",
    method: 'get',
    data: data
  });
};
export var onlineUserCount = function onlineUserCount(data) {
  return service({
    url: "/xcpGameData/onlineUserCount",
    method: 'post',
    data: data
  });
};
export var newRoleCount = function newRoleCount(data) {
  return service({
    url: "/xcpGameData/newRoleCount",
    method: 'post',
    data: data
  });
};
export var payUserRank = function payUserRank(data) {
  return service({
    url: "/xcpGameData/payAnalysis/payUserRank",
    method: 'post',
    data: data
  });
};
export var loadAnalysis = function loadAnalysis(data) {
  return service({
    url: "/xcpGameData/userAnalysis/loadAnalysis",
    method: 'post',
    data: data
  });
};
export var newLoadAnalysis = function newLoadAnalysis(data) {
  return service({
    url: "/xcpGameData/userAnalysis/newLoadAnalysis",
    method: 'post',
    data: data
  });
};
export var ltvGameData = function ltvGameData(data) {
  return service({
    url: "/xcpGameData/payAnalysis/ltvGameData",
    method: 'post',
    data: data
  });
};
export var adLtvGameData = function adLtvGameData(data) {
  return service({
    url: "/xcpGameData/payAnalysis/adLtvGameData",
    method: 'post',
    data: data
  });
};
export var newRoleKeep = function newRoleKeep(data) {
  return service({
    url: "/xcpGameData/userAnalysis/newRoleKeep",
    method: 'post',
    data: data
  });
};
export var userCoin = function userCoin(data) {
  return service({
    url: "/xcpGameData/userAnalysis/userCoin",
    method: 'post',
    data: data
  });
};
export var oldRoleKeep = function oldRoleKeep(data) {
  return service({
    url: "/xcpGameData/userAnalysis/oldRoleKeep",
    method: 'post',
    data: data
  });
};
export var newRolePayKeep = function newRolePayKeep(data) {
  return service({
    url: "/xcpGameData/userAnalysis/newRolePayKeep",
    method: 'post',
    data: data
  });
};
export var payCount = function payCount(data) {
  return service({
    url: "/xcpGameData/payAnalysis/payCount",
    method: 'post',
    data: data
  });
};
export var payCountGoods = function payCountGoods(data) {
  return service({
    url: "/xcpGameData/payAnalysis/payCountGoods",
    method: 'post',
    data: data
  });
};
export var userRoleInfo = function userRoleInfo(data) {
  return service({
    url: "/xcpOpsManager/role/userRoleInfo",
    method: 'post',
    data: data
  });
};
export var enterGameLog = function enterGameLog(data) {
  return service({
    url: "/xcpGameLog/enterGameLog",
    method: 'post',
    data: data
  });
};

//获取充值日志
export var payLog = function payLog(data) {
  return service({
    url: "/xcpGameLog/payLog",
    method: 'post',
    data: data
  });
};

//获取货币日志
export var coinLog = function coinLog(data) {
  return service({
    url: "/xcpGameLog/coinLog",
    method: 'post',
    data: data
  });
};

//获取道具日志
export var goodsLog = function goodsLog(data) {
  return service({
    url: "/xcpGameLog/goodsLog",
    method: 'post',
    data: data
  });
};

//获取道具日志
export var videoFinishLog = function videoFinishLog(data) {
  return service({
    url: "/xcpGameLog/videoFinishLog",
    method: 'post',
    data: data
  });
};

//保存邮件信息
export var saveEmail = function saveEmail(data) {
  return service({
    url: "/xcpOpsManager/email/saveEmail",
    method: 'post',
    data: data
  });
};

//邮件列表
export var EmailList = function EmailList(data) {
  return service({
    url: "/xcpOpsManager/email/emailList",
    method: 'post',
    data: data
  });
};

//获取邮件信息
export var getEmail = function getEmail(data) {
  return service({
    url: "/xcpOpsManager/email/getEmail",
    method: 'post',
    data: data
  });
};

//没分页的 物品列表（还没用上）
export var goodsDetailList = function goodsDetailList(data) {
  return service({
    url: "/xcpOpsManager/goodsDetailList",
    method: 'get',
    data: data
  });
};

//分页的 物品列表
export var goodsListAPI = function goodsListAPI(data) {
  return service({
    url: "/xcpGameData/goods/goodsList",
    method: 'post',
    data: data
  });
};

//下拉框的所有物品列表，负责成为数组
export var goodsList = function goodsList(data) {
  return service({
    url: "/xcpGameData/goodsList",
    method: 'get',
    data: data
  });
};

//审核邮件
export var approveEmail = function approveEmail(data) {
  return service({
    url: "/xcpOpsManager/email/approveEmail",
    method: 'post',
    data: data
  });
};

//邮件发送日志
export var emailSendLog = function emailSendLog(data) {
  return service({
    url: "/xcpOpsManager/email/emailSendLog",
    method: 'post',
    data: data
  });
};

//检查是否有该角色ID
export var checkRole = function checkRole(data) {
  return service({
    url: "/xcpOpsManager/role/checkRole",
    method: 'post',
    data: data
  });
};

//修改服务器状态
export var resendEmail = function resendEmail(data) {
  return service({
    url: "/xcpOpsManager/email/resendEmail",
    method: 'post',
    data: data
  });
};

//获取查看服务器列表
export var serverDetailList = function serverDetailList(data) {
  return service({
    url: "/xcpGameData/serverDetailList",
    method: 'get',
    data: data
  });
};

//修改服务器开服时间
export var editServerOpenTime = function editServerOpenTime(data) {
  return service({
    url: "/xcpOpsManager/server/editServerOpenTime",
    method: 'post',
    data: data
  });
};

//修改服务器状态
export var editServerState = function editServerState(data) {
  return service({
    url: "/xcpOpsManager/server/editServerState",
    method: 'post',
    data: data
  });
};

//修改服务器真实开服时间
export var editServerRealOpenTime = function editServerRealOpenTime(data) {
  return service({
    url: "/xcpOpsManager/server/editServerRealOpenTime",
    method: 'post',
    data: data
  });
};

//元宝分析
export var goldStatement = function goldStatement(data) {
  return service({
    url: "/xcpGameData/actionAnalysis/goldStatement",
    method: 'post',
    data: data
  });
};

//道具分析
export var goodsStatement = function goodsStatement(data) {
  return service({
    url: "/xcpGameData/actionAnalysis/goodsStatement",
    method: 'post',
    data: data
  });
};

//货币流水统计
export var currencyStatement = function currencyStatement(data) {
  return service({
    url: "/xcpGameData/actionAnalysis/currencyStatement",
    method: 'post',
    data: data
  });
};

//等级停留统计
export var levelDwellPoint = function levelDwellPoint(data) {
  return service({
    url: "/xcpGameData/actionAnalysis/levelDwellPoint",
    method: 'post',
    data: data
  });
};

//等级停留统计
export var LevelDwellPointByCreateRoleTime = function LevelDwellPointByCreateRoleTime(data) {
  return service({
    url: "/xcpGameData/actionAnalysis/LevelDwellPointByCreateRoleTime",
    method: 'post',
    data: data
  });
};

//事件停留统计
export var eventStatement = function eventStatement(data) {
  return service({
    url: "/xcpGameData/actionAnalysis/eventStatement",
    method: 'post',
    data: data
  });
};

//在线时长统计
export var OnlineStatement = function OnlineStatement(data) {
  return service({
    url: "/xcpGameData/actionAnalysis/onlineStatement",
    method: 'post',
    data: data
  });
};

//gameNotice游戏公告

//游戏公告添加
export var addNotice = function addNotice(data) {
  return service({
    url: "/xcpOpsManager/gameNotice/addNotice",
    method: 'post',
    data: data
  });
};

//游戏公告列表
export var getList = function getList(data) {
  return service({
    url: "/xcpOpsManager/gameNotice/getList",
    method: 'post',
    data: data
  });
};

//游戏公告修改
export var updateNotice = function updateNotice(data) {
  return service({
    url: "/xcpOpsManager/gameNotice/updateNotice",
    method: 'post',
    data: data
  });
};

//游戏货币类型配置
export var gameCoinConfig = function gameCoinConfig(data) {
  return service({
    url: "/coin/coinConfig",
    method: 'post',
    data: data
  });
};

//伙伴变更日志
export var partnerChangeLog = function partnerChangeLog(data) {
  return service({
    url: "/xcpGameLog/partnerChangeLog",
    method: 'post',
    data: data
  });
};

// 星星日志
export var xingxingLog = function xingxingLog(data) {
  return service({
    url: "/xcpGameLog/xingxingLog",
    method: 'post',
    data: data
  });
};

// 关卡开始日志
export var guanqiaStartLog = function guanqiaStartLog(data) {
  return service({
    url: "/xcpGameLog/guanqiaStartLog",
    method: 'post',
    data: data
  });
};

// 关卡结束日志
export var guanqiaEndLog = function guanqiaEndLog(data) {
  return service({
    url: "/xcpGameLog/guanqiaEndLog",
    method: 'post',
    data: data
  });
};

// 创角日志
export var roleCreateLog = function roleCreateLog(data) {
  return service({
    url: "/xcpGameLog/roleCreateLog",
    method: 'post',
    data: data
  });
};
export var accountLoadingLog = function accountLoadingLog(data) {
  return service({
    url: "/xcpGameLog/accountLoadingLog",
    method: 'post',
    data: data
  });
};

//伙伴变更日志
export var partnerList = function partnerList(data) {
  return service({
    url: "/partner/partnerConfig",
    method: 'post',
    data: data
  });
};

//导出道具日志
export var exportGoodsLog = function exportGoodsLog(params) {
  return service({
    url: "/xcpGameLog/exportGoodsLog",
    method: 'get',
    params: params,
    responseType: 'blob'
  });
};

//付费分析，充值项
export var payItemCount = function payItemCount(data) {
  return service({
    url: "/xcpGameData/payAnalysis/payItemCount",
    method: 'post',
    data: data
  });
};

//首次付费付费分析，充值项
export var payItemFirstCount = function payItemFirstCount(data) {
  return service({
    url: "/xcpGameData/payAnalysis/payItemFirstCount",
    method: 'post',
    data: data
  });
};

// 广告点统计
export var adGameDataCount = function adGameDataCount(data) {
  return service({
    url: "/xcpGameData/payAnalysis/adGameDataCount",
    method: 'post',
    data: data
  });
};

//付费分析，充值项完成曲线
export var payItemLineCount = function payItemLineCount(data) {
  return service({
    url: "/xcpGameData/payAnalysis/payItemLineCount",
    method: 'post',
    data: data
  });
};

//付费分析，首次付费等级
export var firstPayLevel = function firstPayLevel(data) {
  return service({
    url: "/xcpGameData/payAnalysis/firstPayLevel",
    method: 'post',
    data: data
  });
};

//付费分析，首次付费时间
export var firstPayTime = function firstPayTime(data) {
  return service({
    url: "/xcpGameData/payAnalysis/firstPayTime",
    method: 'post',
    data: data
  });
};

//同步cp配置
export var syncCpConfig = function syncCpConfig(params) {
  return service({
    url: "/xcpGameManager/syncCpConfig",
    method: 'get',
    params: params
  });
};

//主线任务日志
export var mainTaskLog = function mainTaskLog(data) {
  return service({
    url: "/xcpGameLog/mainTaskLog",
    method: 'post',
    data: data
  });
};

//导出主线任务日志
export var exportMainTaskLog = function exportMainTaskLog(params) {
  return service({
    url: "/xcpGameLog/exportMainTaskLog",
    method: 'get',
    params: params,
    responseType: 'blob'
  });
};

//反馈列表
export var getSuggestList = function getSuggestList(data) {
  return service({
    url: "/xcpGameManager/getSuggestList",
    method: 'post',
    data: data
  });
};

//反馈回复
export var suggestReply = function suggestReply(data) {
  return service({
    url: "/xcpGameManager/suggestReply",
    method: 'post',
    data: data
  });
};

// 下拉框的所有礼包列表，负责成为数组
export var couponList = function couponList(data) {
  return service({
    url: "/xcpGameData/couponList",
    method: 'get',
    data: data
  });
};

// 获取游戏评分列表
export var getGameRateList = function getGameRateList(data) {
  return service({
    url: "/xcpGameData/gameRate/getGameRateList",
    method: 'post',
    data: data
  });
};

// 关卡数据
export var getGuanqiaData = function getGuanqiaData(data) {
  return service({
    url: "/xcpGameData/guanqia/getGuanqiaData",
    method: 'post',
    data: data
  });
};

// 活跃通关数据
export var getGuanqiaWinData = function getGuanqiaWinData(data) {
  return service({
    url: "/xcpGameData/guanqia/getGuanqiaWinData",
    method: 'post',
    data: data
  });
};

// 老角色通关数据
export var getGuanqiaOldWinData = function getGuanqiaOldWinData(data) {
  return service({
    url: "/xcpGameData/guanqia/getGuanqiaOldWinData",
    method: 'post',
    data: data
  });
};

// 获取关卡流失数据
export var getGuanqiaLostData = function getGuanqiaLostData(data) {
  return service({
    url: "/xcpGameData/guanqia/getGuanqiaLostData",
    method: 'post',
    data: data
  });
};

// 获取新手关卡流失数据
export var getGuanqiaLostData2 = function getGuanqiaLostData2(data) {
  return service({
    url: "/xcpGameData/guanqia/getGuanqiaLostData2",
    method: 'post',
    data: data
  });
};

// 获取关卡留存数据
export var getGuanqiaRetention = function getGuanqiaRetention(data) {
  return service({
    url: "/xcpGameData/guanqia/getGuanqiaRetention",
    method: 'post',
    data: data
  });
};

// 临时接口
export var getFirstEnterTime = function getFirstEnterTime(data) {
  return service({
    url: "/xcpGameData/temp/getFirstEnterTime",
    method: 'post',
    data: data
  });
};

// 访问分析
export var accessAnalysis = function accessAnalysis(data) {
  return service({
    url: "/xcpGameData/userAnalysis/accessAnalysis",
    method: 'post',
    data: data
  });
};

// 角色登录场景分析
export var getRoleEnterSceneData = function getRoleEnterSceneData(data) {
  return service({
    url: "/xcpGameData/userAnalysis/getRoleEnterSceneData",
    method: 'post',
    data: data
  });
};